export enum SCORM_VERSION {
	SCORM_1_2,
	SCORM_2004
}

export enum SCORM_STATE {
	NOT_INITIALIZED,
	RUNNING,
	TERMINATED
}
